const TOKEN_KEY = 'token';

export const setToken = (newToken) => {
  localStorage.setItem(TOKEN_KEY, newToken);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

